import { buildWhatsAppLink } from "@/lib/api";

export default function WhatsAppFloat({ number }) {
  const link = buildWhatsAppLink(number, "Hola Aura, me gustaría más información.");
  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-3 px-5 py-3 rounded-full bg-[#25D366] text-white shadow-[0_15px_30px_rgb(37,211,102,0.35)] hover:scale-105 transition-transform"
    >
      <svg
        viewBox="0 0 24 24"
        width="22"
        height="22"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M20.52 3.48A11.93 11.93 0 0 0 12.06 0C5.5 0 .14 5.36.14 11.92c0 2.1.55 4.15 1.6 5.96L0 24l6.27-1.64a11.91 11.91 0 0 0 5.78 1.47h.01c6.55 0 11.92-5.36 11.92-11.92 0-3.18-1.24-6.17-3.46-8.43Zm-8.46 18.34h-.01a9.9 9.9 0 0 1-5.05-1.39l-.36-.21-3.72.97 1-3.62-.24-.37a9.9 9.9 0 1 1 18.4-5.28 9.9 9.9 0 0 1-10.02 9.9Zm5.43-7.41c-.3-.15-1.77-.87-2.05-.97-.27-.1-.47-.15-.67.15s-.77.97-.95 1.17c-.18.2-.35.22-.65.07-.3-.15-1.27-.47-2.42-1.5-.89-.79-1.49-1.76-1.66-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.49 0 1.47 1.07 2.88 1.22 3.08.15.2 2.11 3.22 5.11 4.51.71.31 1.27.49 1.71.62.72.23 1.37.2 1.88.12.57-.08 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.13-.27-.2-.57-.35Z" />
      </svg>
      <span className="hidden sm:inline text-sm uppercase tracking-[0.16em]">WhatsApp</span>
    </a>
  );
}
